import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconQuestionmark: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconQuestionmark"><Path d="M12 16.5C12 12.5 16.3696 12.5167 16.3696 8.6985C16.3696 3.11583 7.5 2.97153 7.5 9.04197" stroke="currentColor" strokeLinejoin="round"/><Circle cx="12" cy="19.25" r="0.75" fill="currentColor"/></CentralIconBase>;
});

export default IconQuestionmark;
